/* ============================================================
   SORLUMA — interacciones (vanilla JS, sin librerías)
   ============================================================ */
(function () {
  "use strict";
  var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* ---- Reveal al hacer scroll (un solo observer compartido) ---- */
  function initReveal() {
    var els = document.querySelectorAll(".mt-reveal");
    if (!els.length) return;
    if (reduce || !("IntersectionObserver" in window)) {
      els.forEach(function (el) { el.classList.add("mt-visible"); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add("mt-visible"); io.unobserve(e.target); }
      });
    }, { threshold: 0.14, rootMargin: "0px 0px -8% 0px" });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---- Contadores animados ---- */
  function initCounters() {
    var nums = document.querySelectorAll("[data-mt-count]");
    if (!nums.length) return;
    if (reduce || !("IntersectionObserver" in window)) {
      nums.forEach(function (n) { n.textContent = n.getAttribute("data-mt-count"); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target;
        io.unobserve(el);
        var target = parseFloat(el.getAttribute("data-mt-count"));
        var dec = (el.getAttribute("data-mt-count").split(".")[1] || "").length;
        var dur = 1600, start = null;
        function step(ts) {
          if (!start) start = ts;
          var p = Math.min((ts - start) / dur, 1);
          var eased = 1 - Math.pow(1 - p, 3);
          el.textContent = (target * eased).toFixed(dec);
          if (p < 1) requestAnimationFrame(step); else el.textContent = target.toFixed(dec);
        }
        requestAnimationFrame(step);
      });
    }, { threshold: 0.5 });
    nums.forEach(function (n) { io.observe(n); });
  }

  /* ---- Comparador antes/después ---- */
  function initComparador() {
    var sliders = document.querySelectorAll(".mt-comp__slider");
    sliders.forEach(function (s) {
      var before = s.querySelector(".mt-comp__img--before");
      var handle = s.querySelector(".mt-comp__handle");
      var grip = s.querySelector(".mt-comp__grip");
      if (!before || !handle) return;
      var dragging = false;
      function setPos(clientX) {
        var r = s.getBoundingClientRect();
        var x = Math.max(0, Math.min(clientX - r.left, r.width));
        var pct = (x / r.width) * 100;
        before.style.clipPath = "inset(0 " + (100 - pct) + "% 0 0)";
        handle.style.left = pct + "%";
      }
      function down(e) { dragging = true; setPos((e.touches ? e.touches[0] : e).clientX); e.preventDefault(); }
      function move(e) { if (!dragging) return; setPos((e.touches ? e.touches[0] : e).clientX); }
      function up() { dragging = false; }
      (grip || handle).addEventListener("mousedown", down);
      (grip || handle).addEventListener("touchstart", down, { passive: false });
      s.addEventListener("mousedown", down);
      s.addEventListener("touchstart", down, { passive: false });
      window.addEventListener("mousemove", move);
      window.addEventListener("touchmove", move, { passive: true });
      window.addEventListener("mouseup", up);
      window.addEventListener("touchend", up);
    });
  }

  /* ---- FAQ acordeón ---- */
  function initFaq() {
    var items = document.querySelectorAll(".mt-faq__item");
    items.forEach(function (item) {
      var q = item.querySelector(".mt-faq__q");
      var a = item.querySelector(".mt-faq__a");
      if (!q || !a) return;
      q.addEventListener("click", function () {
        var open = item.classList.contains("mt-open");
        if (open) { item.classList.remove("mt-open"); a.style.maxHeight = null; }
        else { item.classList.add("mt-open"); a.style.maxHeight = a.scrollHeight + "px"; }
      });
    });
  }

  /* ---- Galería página de producto ---- */
  function initGallery() {
    var gal = document.querySelector(".mt-pdp__gallery");
    if (!gal) return;
    var main = gal.querySelector(".mt-pdp__main img");
    var thumbs = gal.querySelectorAll(".mt-pdp__thumb");
    if (!main || !thumbs.length) return;
    thumbs.forEach(function (t) {
      t.addEventListener("click", function () {
        var full = t.getAttribute("data-full");
        if (full) main.src = full;
        thumbs.forEach(function (x) { x.classList.remove("mt-active"); });
        t.classList.add("mt-active");
      });
    });
  }

  /* ---- Variantes página de producto ---- */
  function initVariants() {
    var form = document.querySelector(".mt-pdp__form");
    var dataEl = document.getElementById("mt-variant-data");
    if (!form || !dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var idInput = form.querySelector('input[name="id"]');
    var swatches = document.querySelectorAll(".mt-pdp__swatch");
    var priceNow = document.querySelector(".mt-pdp__price-now");
    var addBtn = form.querySelector('button[name="add"]');
    if (!swatches.length) return;
    swatches.forEach(function (sw) {
      sw.addEventListener("click", function () {
        var vid = sw.getAttribute("data-vid");
        var v = variants.filter(function (x) { return String(x.id) === String(vid); })[0];
        if (!v) return;
        swatches.forEach(function (x) { x.classList.remove("mt-active"); });
        sw.classList.add("mt-active");
        if (idInput) idInput.value = v.id;
        if (priceNow && v.price != null) priceNow.textContent = v.price;
        if (addBtn) {
          if (v.available) { addBtn.disabled = false; addBtn.classList.remove("mt-pdp__sold"); addBtn.textContent = addBtn.getAttribute("data-add") || "Añadir al carrito"; }
          else { addBtn.disabled = true; addBtn.classList.add("mt-pdp__sold"); addBtn.textContent = addBtn.getAttribute("data-sold") || "Agotado"; }
        }
        var buyBtn = document.querySelector(".mt-pdp__buynow");
        if (buyBtn) {
          if (v.available) { buyBtn.disabled = false; buyBtn.classList.remove("mt-pdp__sold"); buyBtn.textContent = buyBtn.getAttribute("data-buy") || "Comprar ahora"; }
          else { buyBtn.disabled = true; buyBtn.classList.add("mt-pdp__sold"); buyBtn.textContent = buyBtn.getAttribute("data-sold") || "Agotado"; }
        }
      });
    });
  }

  /* ---- Botón "Comprar ahora" (añade y va directo al pago) ---- */
  function initBuyNow() {
    var btn = document.querySelector(".mt-pdp__buynow[data-checkout]");
    var form = document.querySelector(".mt-pdp__form");
    if (!btn || !form) return;
    btn.addEventListener("click", function () {
      if (btn.disabled) return;
      var idInput = form.querySelector('input[name="id"]');
      if (!idInput || !idInput.value) return;
      var original = btn.textContent;
      btn.disabled = true;
      btn.textContent = "Un momento…";
      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: idInput.value, quantity: 1 })
      }).then(function (r) {
        if (!r.ok) throw new Error("add failed");
        window.location.href = "/checkout";
      }).catch(function () {
        btn.disabled = false;
        btn.textContent = original;
        form.submit();
      });
    });
  }

  function boot() {
    initReveal(); initCounters(); initComparador(); initFaq(); initGallery(); initVariants(); initBuyNow();
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
})();
